import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import "./index.css";

import App from "./components/App";

import { StoreProvider } from "./store/provider";

import * as Sentry from "@sentry/react";
Sentry.init({
  dsn: "https://d022af43f7006eb01435337341236c73@o4508693055012864.ingest.de.sentry.io/4508693099970640",
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [/^https:\/\/ciidapidev\.proclime\.world/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const queryClient = new QueryClient();

root.render(
  <QueryClientProvider client={queryClient}>
    <StoreProvider>
      <BrowserRouter>
        <StrictMode>
          <App />
        </StrictMode>
      </BrowserRouter>
    </StoreProvider>
  </QueryClientProvider>,
);
